const matchSortOption = (attribute, order, options) => {
  const matchOption = options.find( option => {
    const matchBy = option?.attribute === attribute;
    const matchOrder = order ? option?.order === order : true;  
    return matchBy && matchOrder;
  });
  return matchOption;
}

const getSelectedSortLabel = (sortApplied, defaultSorting, options) => {
  if(!options?.length) {
    return '';
  }

  const label = options?.[0]?.label || '';

  const [ defaultAttribute, defaultOrder ] = defaultSorting ? Object.values(defaultSorting) : [];
  const defaultOption = matchSortOption(defaultAttribute, defaultOrder, options);

  if (!sortApplied?.length) {
    return defaultOption?.label ? defaultOption.label : label;
  }

  const [attribute, order] = sortApplied;
  const sortAppliedOption = matchSortOption(attribute, order, options);
  return sortAppliedOption?.label || label;
};

export { getSelectedSortLabel };